import { CurrentUserRepository } from '../../domain/repository';
import { CurrentUserStore, UiState } from '../../domain/store';
import { ErrorReporter } from '../../infrastructure/adapter/ErrorReporter';
import { ZopimHandler } from '../../infrastructure/adapter/ZopimHandler';
import config from '../../config';

export class AuthenticationUsecase {
  private currentUserRepository: CurrentUserRepository;
  private currentUserStore: CurrentUserStore;
  private errorReporter: ErrorReporter;
  private zopimHandler: ZopimHandler;
  private uiState: UiState;

  constructor({
    currentUserRepository,
    currentUserStore,
    errorReporter,
    zopimHandler,
    uiState,
  }: {
    currentUserRepository: CurrentUserRepository;
    currentUserStore: CurrentUserStore;
    errorReporter: ErrorReporter;
    zopimHandler: ZopimHandler;
    uiState: UiState;
  }) {
    this.currentUserRepository = currentUserRepository;
    this.currentUserStore = currentUserStore;
    this.errorReporter = errorReporter;
    this.zopimHandler = zopimHandler;
    this.uiState = uiState;
  }

  public async authenticate() {
    const { currentUserRepository, currentUserStore, errorReporter, zopimHandler, uiState } = this;
    const user = await currentUserRepository.getCurrentUser().catch(err => {
      uiState.setError({
        title: 'ログインしてください',
        message: `お手数ですが、ログインした後にもう一度アクセスしてください。`,
        actionLabel: 'ログイン画面を開く',
        action: () => window.open(`${config.dashboard}/login`),
      });
      throw err;
    });
    currentUserStore.setCurrentUser(user);
    errorReporter.setUser({
      id: currentUserStore.currentUser.id,
      name: currentUserStore.currentUser.username,
    });
    zopimHandler.setUser({
      name: currentUserStore.currentUser.username,
      email: currentUserStore.currentUser.email,
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/application/usecase/AuthenticationUsecase.ts